import { AdminMe } from '@core/domains/adminMe/admin-me';
import { AdminMeStoreService } from '@core/domains/adminMe/adminMe-store.service';
import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { mergeMap } from 'rxjs/internal/operators/mergeMap';


@Injectable()
export class PermissionsGuardService  {

  constructor(
    private router: Router,
    private adminStore: AdminMeStoreService,
  ) { }

  canActivate(): Observable<boolean|UrlTree> {
    return this.adminStore.$adminMe.pipe(
      mergeMap((me: AdminMe) => of((me.role === 'admin' || me.role === 'adminless') ? true : this.router.parseUrl(me.defaultModulePath) ))
    )
  }
}
